module.exports = __webpack_public_path__ + "static/media/Shop-By-Tire-Brand-White.85ddc7f1.svg";